import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "py-2 px-10"
};
const _hoisted_2 = {
  class: "text-black"
};
const _hoisted_3 = {
  class: "block pb-8"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "py-4 pr-4"
};
import { computed, reactive } from 'vue';
import MaxioProductDeal from './MaxioProductDeal.vue';
// Props

export default {
  __name: 'MaxioSubscriptionList',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: false
    },
    interval: {
      type: String,
      required: true
    },
    selectedPlan: {
      type: Object,
      required: false
    },
    isSmallScreen: {
      type: Boolean,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  emits: ['subscription-updated', 'selected-subscription-plan'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const subscriptionListState = reactive({
      loading: false,
      currentSelectedPlan: {}
    });
    const emit = __emit;
    const recommended = computed(() => {
      return !props.selectedPlan && props.interval === 'yearly' && (props.product?.leanlawProductId === 'pioneer' || props.product?.leanlawProductId === 'pro');
    });
    const plans = computed(() => {
      return props.product?.products?.filter(p => {
        if (props.interval === 'yearly') {
          return p.interval === 'yearly';
        } else {
          return p.interval === 'monthly';
        }
      });
    });
    const selected = plan => {
      emit('selected-subscription-plan');
      // Always set the current selected plan so UI can highlight it
      if (plan) {
        subscriptionListState.currentSelectedPlan = plan;
      } else if (props.subscription?.product) {
        subscriptionListState.currentSelectedPlan = props.subscription.product;
      }
      return props.subscription?.product?.id === subscriptionListState.currentSelectedPlan?.id;
    };
    const subscriptionUpdated = () => {
      emit('subscription-updated');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [recommended.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["px-10 py-2 bg-primary rounded-t-lg", {
          'text-center': __props.isSmallScreen
        }])
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
        class: "text-white"
      }, [_createElementVNode("i", {
        class: "fa fa-star"
      }), _createTextVNode(" Recommended for You")], -1)]))], 2)) : _createCommentVNode("", true), plans.value && plans.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["flex flex-row justify-between", {
          'flex-col': __props.isSmallScreen
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'text-center': __props.isSmallScreen
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.product?.label), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.product?.description), 1), __props.product?.link ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: __props.product?.link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
        class: "text-primary pr-2"
      }, "Learn More", -1), _createElementVNode("span", {
        class: "text-primary fa fa-arrow-right"
      }, null, -1)]))], 8, _hoisted_4)) : _createCommentVNode("", true)])], 2), __props.selectedPlan ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(MaxioProductDeal, {
        product: __props.product,
        alerts: __props.alerts,
        plan: __props.selectedPlan,
        actionLabel: 'Selected',
        actionDisabled: true,
        isSmallScreen: __props.isSmallScreen,
        onSubscriptionUpdated: subscriptionUpdated,
        onSelectedSubscriptionPlan: _cache[0] || (_cache[0] = $event => selected())
      }, null, 8, ["product", "alerts", "plan", "isSmallScreen"])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plans.value, plan => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["flex flex-row", {
            'flex-col justify-center items-center': __props.isSmallScreen
          }]),
          key: plan.id
        }, [_createElementVNode("div", {
          class: _normalizeClass(["relative", {
            'ring-2 ring-[rgb(var(--v-theme-primary))] rounded-lg': plan.id === __props.subscription?.product?.id
          }])
        }, [_createVNode(MaxioProductDeal, {
          product: __props.product,
          alerts: __props.alerts,
          plan: plan,
          actionLabel: plan.id === __props.subscription?.product?.id ? 'Selected' : 'Select',
          actionDisabled: plan.id === __props.subscription?.product?.id,
          isSmallScreen: __props.isSmallScreen,
          selectedProduct: subscriptionListState?.currentSelectedPlan,
          onSubscriptionUpdated: subscriptionUpdated,
          onSelectedSubscriptionPlan: $event => selected(plan)
        }, null, 8, ["product", "alerts", "plan", "actionLabel", "actionDisabled", "isSmallScreen", "selectedProduct", "onSelectedSubscriptionPlan"])], 2)], 2);
      }), 128))]))], 2)) : _createCommentVNode("", true)], 64);
    };
  }
};